import { Box, Grid, MenuItem, Select, Typography } from "@mui/material";
import { Item } from "../../styles/common";
import { useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Table } from "../../common/table/Table";
import { FEEDBACKS } from "./feedback.queries";
import { UPDATE_FEEDBACK_STATUS } from "./feedback.mutation";
import { config } from "../../config";

const perPage = config.rowsPerPage;

export const Feedback = () => {
  let variables = React.useRef<any>({
    "pagination": {
      "skip": 0,
      "take": perPage
    }
  });

  const { data, loading, refetch } = useQuery(FEEDBACKS, { variables });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(perPage);

  const [updateFeedbackStatus] = useMutation(UPDATE_FEEDBACK_STATUS);

  React.useEffect(() => {
    variables.current = {
      pagination: {
        take: rowsPerPage,
        skip: page * rowsPerPage,
      }
    };

    refetch(variables.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  if (loading) return <h4>Loading...</h4>;

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography sx={{ m: 2 }} variant="h4">Feedback</Typography>
            </Grid>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Item>
            <Table
              page={page}
              setPage={setPage}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              loading={loading}
              columns={[
                {
                  label: 'Email',
                  key: 'email',
                },
                {
                  label: 'User',
                  key: 'User',
                  rowRender: (row) => `${row.User.firstName} ${row.User.lastName} (${row.User.username})`,
                },
                {
                  label: 'Category',
                  key: 'category',
                },
                {
                  label: 'Message',
                  key: 'message',
                },
                {
                  label: 'Status',
                  key: 'status',
                  rowRender: (row) => <StatusSelect
                    id={row.id}
                    status={row.status}
                    onChange={(e: any) => {
                      updateFeedbackStatus({
                        variables: {
                          id: parseInt(row.id),
                          status: e.target.value,
                        },
                      });
                      refetch(variables.current);
                    }}
                  >
                    <MenuItem value="PENDING">Pending</MenuItem>
                    <MenuItem value="RESOLVED">Resolved</MenuItem>
                  </StatusSelect>
                },
                {
                  label: 'Media',
                  key: 'Media',
                  rowRender: (row) => row.Media ? <img width={150} src={row.Media.url} alt="Media" /> : null,
                },
                // {
                //   label: "",
                //   key: "action",
                //   textAlign: "right",
                //   type: columnTypes.EDIT,
                //   actionFn: editFn,
                // },
              ]}
              rows={data.fetchUserFeedbacks.userFeedbacks}
              total={data.fetchUserFeedbacks.total}
            />
          </Item>
        </Grid>
      </Grid>
    </Box>
  );
}

const StatusSelect = (props: any) => {
  const [status, setStatus] = useState<string>(props.status);
  return <Select
    value={status}
    onChange={(e: any) => {
      setStatus(e.target.value);
      props.onChange(e);
    }}
  >
    <MenuItem value="PENDING">Pending</MenuItem>
    <MenuItem value="RESOLVED">Resolved</MenuItem>
  </Select>
}